<template>
    <div class="mainHome">
        <div class="mainHome--hero">
            <div class="mainHome--hero--id">
                <div class="mainHome--goya">{{ $t('main.myGoya') }}</div>
                <div class="mainHome--user">{{ userNum }}</div>
            </div>
            <div class="mainHome--hero--welcome member-level-fold-wrap">
                <!-- 접기/펼치기 버튼 -->
                <button
                    type="button"
                    class="member-level-toggle-btn"
                    :class="{ open: isMemberLevelOpen }"
                    @click="toggleMemberLevel"
                    aria-label="member level toggle"
                >
                    <img src="@/assets/images/icon/arrow/arrow-right-orange.png" alt="arrow icon"/>
                </button>

                <!-- member_level 접힘 영역 -->
                <transition name="member-level-slide">
                    <div class="member_level_panel" v-show="isMemberLevelOpen">
                        <!-- 펼쳤는데 로딩 중일 때만 로딩바 -->
                        <div class="loading_spinner" v-if="loadStatus === false">
                            <div class="loading_circle"></div>
                        </div>

                        <!-- 펼쳤고 로딩 끝났을 때만 레벨 이미지 -->
                        <div class="member_level" v-else>
                            <img :src="getImagePath()">
                        </div>
                    </div>
                </transition>

                <div class="mainHome--hero--welcomeText">
                    <div class="mainHome-welcome-welcome">{{ $t('main.welcome') }}</div>
                    <div class="mainHome-welcome-user">{{ userName }}</div>
                </div>
            </div>
            <div class="mainHome--ment">
                Explore Crypto,<br />
                With Clarity
            </div>
        </div>

        <div class="mainHome--market">
            <TradingViewTicker />
        </div>

        <div class="mainHome--menu" @click="goToAlarm">
            <div class="mainHome--menu--title">
                <img src="@/assets/images/home/alert.png" alt="">
                <div class="mainHome--title">
                    <div>{{ $t('main.goyaAlert') }}</div>
                    <p class="sub--title">{{ $t('main.viewAlarm') }}</p>
                </div>
            </div>
            <div class="mainHome--menu--subTitle">
                <img src="@/assets/images/icon/arrow/arrow-right-gray.png" alt="">
            </div>
        </div>

        <div class="mainHome--menu" @click="goToBoard">
            <div class="mainHome--menu--title">
                <img src="@/assets/images/home/briefing.png" alt="">
                <div class="mainHome--title">
                    <div>{{ $t('main.goyaBrief') }}</div>
                    <p class="sub--title">{{ $t('main.viewBrief') }}</p>
                </div>
            </div>
            <div class="mainHome--menu--subTitle">
                <img src="@/assets/images/icon/arrow/arrow-right-gray.png" alt="">
            </div>
        </div>

        <div class="mainHome--invite">
            <div class="mainHome--invite--title">
                <div class="invite--title">{{ $t('mypage.inviteLink') }}</div>
                <div class="mainHome--invite--link">
                    <p>{{ defaultInviteLink }}</p>
                    <img @click="handleCopy" src="@/assets/images/dark/icon_copy.png" alt="">
                </div>
            </div>
            <qrcode-vue :value="defaultInviteLink" :size="computedSize" ref="qrCanvas" tag="canvas"
                style="border: 1px solid var(--Grayscale-Gray60, #575D66); width: 78px; height:  78px; padding: 5px;" />
        </div>
    </div>
</template>

<script setup>
// import { ref, onBeforeMount, onMounted, watch, computed } from 'vue';
import { ref, onMounted, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

// import { copyText } from '@/utils/copy';
import TradingViewTicker from '@/components//trading/TradingViewTicker.vue';
import { popupControll } from '@/utils/modalText';
import api from '@/api/apiAuth';
import apiUser from "@/api/apiUser";
import QrcodeVue from 'qrcode.vue';

// Variables
const userNum = ref(localStorage.getItem('userNum'));
const userName = ref(localStorage.getItem('userName'));
const defaultInviteLink = ref(null);
const loadStatus = ref(false);
const level = ref(null);

const computedSize = 78;

// Store
const store = useStore();
const loginSuccessful = computed(() => store.state.loginStatus.loginSuccessful);

// Router
const router = useRouter();

// Functions
const loadSuccess = () => {
    if (window.webkit?.messageHandlers?.loadHandler) {
        window.webkit.messageHandlers.loadHandler.postMessage('Load state changed.');
    }
    if (window.Android?.loadTriggered) {
        window.Android.loadTriggered();
    }
    userNum.value = localStorage.getItem('userNum');
    userName.value = localStorage.getItem('userName');
    console.log('Load success triggered!');
};

const goToAlarm = () => {
    router.push('/alarm');
};

const goToBoard = () => {
    router.push('/board');
};

const handleCopy = () => {
    copyText(defaultInviteLink.value);
    popupControll('Invite link copied!');
};

const isMemberLevelOpen = ref(false);

const toggleMemberLevel = () => {
    isMemberLevelOpen.value = !isMemberLevelOpen.value;
};

const getImagePath = () => {
    return require("@/assets/images/level/level_" + level.value + ".png");
};


async function fetchDefaultInviteLink() {
    try {
        const response = await api.getLinkDefault();
        if (response.isSuccess) {
            defaultInviteLink.value = response.data.inviteUrl;
            loadSuccess();
        }
    } catch (error) {
        console.error('Error fetching default invite link:', error.message);
    }
}

async function setLang() {
    try {
        const response = await apiUser.getLang();
        if (response.isSuccess) {
            localStorage.setItem("deviceLang", String(response.data));
        }
    } catch (error) {
        console.error('Error fetching device language:', error.message);
    }
}

async function getDashboard() {
    try {
        const response = await apiUser.getDashboard();
        if (response.isSuccess) {
            level.value = response.data.level;
            loadStatus.value = true;
        }
    } catch (error) {
        console.error('Error fetching dashboard:', error.message);
    }
}

async function chkLang() {
    try {
        const lang = localStorage.getItem('localeLang') || 'en';
        console.log('lang', lang)
        await api.chkUserLang(lang);
    } catch (error) {
        console.error('Error patching language:', error.message);

    }
}

function copyText(text) {
    if (!text) return;

    if (navigator.clipboard) {
        navigator.clipboard.writeText(text).catch((err) => {
            console.error('Clipboard API failed:', err);
        });
    } else {
        // Fallback for unsupported browsers
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
        } catch (err) {
            console.error('execCommand fallback failed:', err);
        }
        document.body.removeChild(textarea);
    }
}

// Watchers
watch(loginSuccessful, async (newVal) => {
    if (newVal === true) {
        await fetchDefaultInviteLink();
        await getDashboard();
        await chkLang();
    }
});

// Lifecycle Hooks
onMounted(() => {
    fetchDefaultInviteLink();
    getDashboard();
    setLang();
});

// onBeforeMount(() => {
//     getDashboard();
// });
</script>

<style scoped>
.mainHome--hero--welcome {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 70px;

    /* 버튼 자리 확보 */
    padding-left: 20px;
}

.member-level-fold-wrap {
    position: relative;
    overflow: visible;
}

.member_level_panel {
    flex-shrink: 0;
}

.member-level-toggle-btn {
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 5;

    width: 22px;
    height: 70px;
    padding: 0;
    border: 0;
    border-radius: 0 20px 20px 0;
    background: var(--Grayscale-Gray80, #2D3033);

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    transform: translateY(-50%);
}

.member-level-toggle-btn span {
    width: 0;
    height: 0;

    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 8px solid rgba(255, 255, 255, 0.78);
    transition: transform 0.2s ease;
}

.member-level-toggle-btn.open {
    display: none;
}

.member-level-toggle-btn.open span {
    transform: rotate(180deg);
}

.loading_spinner {
    margin: 0;
    padding: 0;
    width: 60px;
    height: 70px;
}

.member_level {
    background-color: var(--Grayscale-Gray90);
    height: 64px;
    border-radius: 30%;
    width: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.member_level img {
    width: 40px;
    height: 42px;
    margin: 0;
    padding: 0;
}
</style>

